<template>
  <div class="cut-frame" :style="{'z-index': 25}" v-show="isShow" @keydown.stop>
    <div
      class="cut-backdrop"
      v-dragWhole
      :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}"
    >
      <div class="cut-position" :style="cutPositionStyle">
        <div class="content" :style="contentStyle">
          <div class="frame-mask" ref="frameMask"></div>
          <div class="frame-image" ref="frameImage"></div>
          <div class="frame-content" ref="frameContent"></div>
        </div>
        <div class="content-help" data-action="move" :style="handleStyle">
          <div
            :class="'op-handle-point op-handle-' + point.action"
            v-for="point in contentPoint"
            :data-action="point.action"
            :style="point.pt"
          ></div>
          <!-- 角度显示部分 -->
          <div
            v-show="sprite && dataAction === 'spin'"
            class="rotate-cut"
            :style="rotateCutStyle"
          >{{seeDeg}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dragFn from "@/components/mixins/forDragFn";

export default {
  mixins: [dragFn],
  data() {
    return {
      isShow: false, // 裁剪页面是否显示
      sprite: null,
      content: {
        // 相框的位置等信息
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        rotate: 0,
        flip: false,
        opacity: 1
      },
      ratio: 0, // 相框和真实宽高的比例
      handle: {
        // 帮助框的位置等信息
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        rotate: 0
      },
      matrix: null, // 处理后的matrix等信息
      picDom: null, // 图片Dom(下面有遮罩的)
      picDomO: null, // 图片Dom(上面透明的)
      contentPoint: [
        // 帮助层按钮，缩放和旋转
        { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
        { pt: { left: "-6px", top: "-6px" }, action: "nw" },
        { pt: { right: "-6px", top: "-6px" }, action: "ne" },
        {
          pt: { right: "-6px", bottom: "-6px", left: "auto", top: "auto" },
          action: "se"
        },
        { pt: { right: "-20px", bottom: "-20px" }, action: "spin" }
      ],
      pitchOn: {}, // 拖动产生的中间信息
      mpos: null,
      dataAction: "",
      seeDeg: "0°", // 旋转角度显示
      cursorArr: [
        "s-resize",
        "sw-resize",
        "w-resize",
        "nw-resize",
        "n-resize",
        "ne-resize",
        "e-resize",
        "se-resize"
      ]
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "SelectSprites_Msg",
      "TOOL",
      "MaterialPane_Size",
      "TopNav_Size"
    ]),
    cutPositionStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.height = this.TOOL.clientHeight + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
      return style;
    },
    contentStyle() {
      const style = {};
      style.width = this.content.width + "px";
      style.height = this.content.height + "px";
      style.top = this.content.top + "px";
      style.left = this.content.left + "px";
      style.opacity = this.content.opacity;
      style.transform =
        "rotate(" +
        this.content.rotate +
        "deg)" +
        (this.content.flip ? " scaleX(-1)" : "");
      return style;
    },
    handleStyle() {
      const style = {};
      style.width = this.handle.width + "px";
      style.height = this.handle.height + "px";
      style.top = this.handle.top + "px";
      style.left = this.handle.left + "px";
      style.transform = "rotate(" + this.handle.rotate + "deg)";
      return style;
    },
    rotateCutStyle() {
      const style = {};
      style.transform = "rotate(" + -this.handle.rotate + "deg)";
      return style;
    }
  },
  mounted() {
    this.$bus.on("cutFrame_vue", () => {
      this.initData();
    });
  },
  watch: {
    "TOOL.clientWidth"(val, oldVal) {
      this.isShow && this.initData(true);
    },
    "TOOL.clientHeight"(val, oldVal) {
      this.isShow && this.initData(true);
    }
  },
  methods: {
    initData(noDom) {
      // 初始化数据（包括复制的元素层和帮助层的大小位置）
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        this.$store.commit("toggle_isPreventDefault", false);
        this.sprite = this.SelectSprites_Msg[0];
        this.isShow = true;
        this.sprite.showHideSpriteDom(false);

        this.content = {
          width: this.sprite.width,
          height: this.sprite.height,
          top: this.sprite.positionTop,
          left: this.sprite.positionLeft,
          rotate: this.sprite.rotate,
          flip: this.sprite.flip,
          opacity: this.sprite.opacity
        };

        let matrix = this.matrix || this.sprite.picData.matrix;
        // 获取元素整体中心点和相框中心点
        let spriteC = {
          x: this.sprite.frameData.viewBox[2] / 2,
          y: this.sprite.frameData.viewBox[3] / 2
        };
        let frameC = {
          x: matrix.width / 2 + matrix.x,
          y: matrix.height / 2 + matrix.y
        };
        // 计算原点分别绕元素整体中心点和相框中心点后的位置（用以计算帮助框定位偏差）
        let oo1 = this._rotateWithPoint(
          { x: 0, y: 0 },
          spriteC,
          this.sprite.rotate
        );
        let oo2 = this._rotateWithPoint(
          { x: 0, y: 0 },
          frameC,
          this.sprite.rotate
        );

        this.ratio = this.sprite.width / +this.sprite.frameData.viewBox[2];

        this.handle.width = matrix.width * this.ratio;
        this.handle.height = matrix.height * this.ratio;
        // 元素是否有镜像，以确定帮助框的旋转角度
        this.handle.rotate =
          this.sprite.rotate + matrix.rotate * (this.sprite.flip ? -1 : 1);
        this.handle.top =
          this.sprite.positionTop +
          matrix.y * this.ratio +
          (oo1.y - oo2.y) * this.ratio;
        this.handle.left =
          this.sprite.positionLeft +
          matrix.x * this.ratio +
          (oo1.x - oo2.x) * this.ratio;

        if (this.sprite.flip) {
          //　元素镜像后，获取镜像直线line
          let center = {
            x: this.sprite.positionLeft + this.sprite.width / 2,
            y: this.sprite.positionTop + this.sprite.height / 2
          };
          this.line = this._getLine(center, -this.sprite.rotate);
          // 获取帮助框中心点以直线line镜像后的位置（用已计算定位的偏差）
          let hCenter = {
            x: this.handle.left + this.handle.width / 2,
            y: this.handle.top + this.handle.height / 2
          };
          let pos = this._getFlipPoint(this.line, hCenter);
          // 之后获取镜像后帮助框应该在的位置
          this.handle.top = pos.y - this.handle.height / 2;
          this.handle.left = pos.x - this.handle.width / 2;
        }

        this.seeDeg = Math.round(this.handle.rotate) + "°";
        this.setCursor(this.handle.rotate);
        !noDom && this.initDom();
      } else {
        this.cancel();
      }
    },
    initDom() {
      // 生成Dom和绑定Dom
      let draw = SVG("sprite-svg-" + this.sprite.uuid);
      let viewBox = draw.attr("viewBox");

      let maskId = "frame-cut-" + this.sprite.uuid + "-clip-path";
      this.$refs.frameContent.appendChild(draw.node.cloneNode(true));

      let maskPathDom = draw.select(".imageHolderMaskPath");
      // clip-path的SVG
      var maskDom = SVG(this.$refs.frameMask).attr({
        viewBox: viewBox,
        x: 0,
        y: 0,
        width: "100%",
        height: "100%"
      });
      // 在maskDom 中生成clipPath元素
      var clipPath = maskDom
        .defs()
        .clip()
        .attr({
          id: maskId
        });
      clipPath.add(maskPathDom.members[0].clone());
      // 图片的SVG
      this.picDom = this.sprite.picData.picDom.clone();
      this.picDomO = this.sprite.picData.picDom.clone().style("opacity", 0.2);
      var imgContentDom = SVG(this.$refs.frameImage)
        .attr({
          viewBox: viewBox,
          x: 0,
          y: 0
        })
        .style("overflow", "visible");
      var picContent = imgContentDom
        .group()
        .attr("clip-path", "url(#" + maskId + ")");
      imgContentDom.add(this.picDomO);
      picContent.add(this.picDom);
    },
    dragDown(disx, dataAction) {
      // mousedown数据的初始位置
      if (!dataAction) {
        return;
      }
      this.sprite.showHideSpriteDom(false);
      this.dataAction = dataAction;
      this.pitchOn = Object.assign({}, this.handle);
      this.mpos = Object.assign(
        {
          x: disx.x - this.TOOL.PfixLeft,
          y: disx.y - this.TOOL.PfixTop,
          cx: this.pitchOn.left + this.pitchOn.width / 2,
          cy: this.pitchOn.top + this.pitchOn.height / 2
        },
        this.pitchOn
      );

      this.mpos.deg = this._levelDeg(
        this.mpos.x,
        this.mpos.y,
        this.mpos.cx,
        this.mpos.cy
      );
      this.mpos.mdeg = this.mpos.deg;
      this.mpos.direction = true;
    },
    dragMove(pos) {
      // mousemove数据的变化
      if (!this.dataAction) {
        return;
      }
      pos.x -= this.TOOL.PfixLeft;
      pos.y -= this.TOOL.PfixTop;
      if (this.dataAction === "move") {
        this.pitchOn.left = this.mpos.left + pos.x - this.mpos.x;
        this.pitchOn.top = this.mpos.top + pos.y - this.mpos.y;
      } else if (this.dataAction === "spin") {
        let degree = this._levelDeg(pos.x, pos.y, this.mpos.cx, this.mpos.cy);
        if (degree >= this.mpos.mdeg) {
          if (this.mpos.direction == false) {
            this.mpos.direction = true;
            this.mpos.rotate = this.pitchOn.rotate;
            this.mpos.deg = degree;
          }
        } else {
          if (this.mpos.direction == true) {
            this.mpos.direction = false;
            this.mpos.rotate = this.pitchOn.rotate;
            this.mpos.deg = degree;
          }
        }
        this.mpos.mdeg = degree;
        this.pitchOn.rotate = (this.mpos.rotate + degree - this.mpos.deg) % 360;
        this.seeDeg = Math.round(this.pitchOn.rotate) + "°";
      } else {
        // 缩放情况下确保对应角保持不动
        let direction = "";
        switch (this.dataAction) {
          case "se":
            direction = "top-left";
            break;
          case "sw":
            direction = "top-right";
            break;
          case "nw":
            direction = "bottom-right";
            break;
          case "ne":
            direction = "bottom-left";
            break;
        }
        let scaleSize = Math.abs(
          this._scaleSize(
            pos.x,
            pos.y,
            this.mpos.x,
            this.mpos.y,
            this.mpos.cx,
            this.mpos.cy
          )
        );
        this.pitchOn.width = this.mpos.width * scaleSize;
        this.pitchOn.height = this.mpos.height * scaleSize;
        let position = this._rotSize(
          this.pitchOn.width,
          this.pitchOn.height,
          this.mpos.width,
          this.mpos.height,
          this.mpos.left,
          this.mpos.top,
          this.pitchOn.rotate,
          direction
        );
        this.pitchOn.left = position.left;
        this.pitchOn.top = position.top;
      }
      this.handle = Object.assign({}, this.pitchOn);
      this.changeAttr();
    },
    dragUp() {
      // mouseUp事件，点击空白地方保存设置
      if (!this.dataAction) {
        this.matrix && this.sprite.setPicMatrix(this.matrix, true);
        this.cancel();
      } else if (this.dataAction === "spin") {
        this.setCursor(this.handle.rotate);
      }
      this.dataAction = null;
      this.mpos = null;
    },
    handleTomatrix() {
      // 此方法是根据相框的位置大小旋转信息获取图片DOM正确的matrix信息(其实也是initData求解的逆函数)
      let ht, hl;
      if (this.sprite.flip) {
        // 如果有镜像，会先将帮助框在镜像一遍已获取图片正常的定位位置
        let hCenter = {
          x: this.handle.left + this.handle.width / 2,
          y: this.handle.top + this.handle.height / 2
        };
        let pos = this._getFlipPoint(this.line, hCenter);

        ht = pos.y - this.handle.height / 2;
        hl = pos.x - this.handle.width / 2;
      } else {
        ht = this.handle.top;
        hl = this.handle.left;
      }
      // 下面一系列赋值在于简化求解方程的一系列因式（逆函数其实只是二元一次方程而已）
      let t = this.sprite.positionTop,
        l = this.sprite.positionLeft,
        d = this.ratio,
        cos = Math.cos((this.sprite.rotate * Math.PI) / 180),
        sin = Math.sin((this.sprite.rotate * Math.PI) / 180),
        w = this.handle.width / d / 2,
        h = this.handle.height / d / 2,
        x0 = this.sprite.frameData.viewBox[2] / 2,
        y0 = this.sprite.frameData.viewBox[3] / 2;

      // 通过合并已知项得下面方程式(于是有下面求解过程)
      // c = ax - by
      // c2 = ay + bx
      let c = (hl - l) / d - w * cos + x0 * cos - y0 * sin + h * sin - x0 + w,
        c2 = (ht - t) / d - w * sin + x0 * sin - h * cos + y0 * cos - y0 + h;
      let a = cos,
        b = sin,
        x,
        y;

      if (a === 0) {
        x = c2 / b;
        y = -c / b;
      } else if (b === 0) {
        x = c / a;
        y = c2 / a;
      } else {
        x = (b * c2 + a * c) / (b * b + a * a);
        y = (a * x - c) / b;
      }

      let calcM = {
        width: w * 2,
        height: h * 2,
        y: y,
        x: x,
        rotate:
          (this.handle.rotate - this.sprite.rotate) /
          (this.sprite.flip ? -1 : 1)
      };
      return calcM;
    },
    changeAttr() {
      // mousemove 实时改变图片的matrix等信息
      let matrix = this.handleTomatrix();
      let transform = `rotate(${matrix.rotate} ${matrix.width / 2 +
        matrix.x} ${matrix.height / 2 + matrix.y})`;
      this.matrix = { ...{}, ...matrix, ...{ transform: transform } };
      this.picDom.attr(this.matrix);
      this.picDomO.attr(this.matrix);
    },
    setCursor(deg) {
      let showClassArr = [],
        sliceIndex = 0;

      if (deg < -22.5) {
        deg = deg + 360;
      } else if (deg > 347.5) {
        deg = deg - 360;
      }

      // 每隔45° 数组变化一次，将第一个数据放入到最后
      sliceIndex = parseInt((deg + 22.5) / 45);
      showClassArr = this.cursorArr
        .slice(sliceIndex)
        .concat(this.cursorArr.slice(0, sliceIndex));

      for (var i = 0; i < this.contentPoint.length - 1; i++) {
        this.contentPoint[i].pt.cursor = showClassArr[i * 2 + 1];
      }
    },
    cancel() {
      // 关闭并初始化数据
      this.sprite.showHideSpriteDom(true);
      this.sprite.action = null;
      this.sprite = null;
      this.picDom = null;
      this.picDomO = null;
      this.$refs.frameMask.innerHTML = "";
      this.$refs.frameImage.innerHTML = "";
      this.$refs.frameContent.innerHTML = "";
      this.isShow = false;
      this.matrix = null;
      this.$store.commit("toggle_isPreventDefault", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.cut-frame {
  position: absolute;
  top: 0;
  left: 0;
}
.cut-backdrop {
  position: fixed;
  background-color: rgba(248, 248, 248, 0.75);
}
.cut-position,
.content,
.content-help {
  position: absolute;
}
.content-help {
  box-sizing: border-box;
  border: 1px dashed #37484f;
}
.rotate-cut {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  width: 30px;
  height: 30px;
  line-height: 28px;
  color: #fff;
  font-size: 11px;
  border: 1px solid #fff;
  border-radius: 50%;
  user-select: none;
  background: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/CutFrame.vue